module.exports = __webpack_public_path__ + "static/media/icon-wheelchair.b315e43d.svg";